import React, { useState } from "react";
import { Dialog, DialogContent } from "../../ui/Dialog";
import { cn } from "../../../lib/utils";

interface DocsImageWithCaptionProps {
  src: string;
  alt: string;
  caption?: string;
  className?: string;
}

export function DocsImageWithCaption({
  src,
  alt,
  caption,
  className,
}: DocsImageWithCaptionProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  return (
    <>
      <figure className={cn("my-6", className)}>
        <div
          className="relative group cursor-pointer"
          onClick={() => setIsOpen(true)}
        >
          <img
            src={src}
            alt={alt}
            loading="lazy"
            className={cn(
              "w-full h-auto rounded-none border border-[var(--su-border-primary)]",
              "transition-opacity",
              isLoading && "opacity-0",
              !isLoading && "opacity-100",
            )}
            onLoad={() => setIsLoading(false)}
            onError={() => setIsLoading(false)}
          />
          {isLoading && (
            <div className="absolute inset-0 bg-[var(--su-bg-secondary)] animate-pulse" />
          )}
          <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors pointer-events-none" />
        </div>
        {caption && (
          <figcaption className="mt-2 text-sm text-[var(--su-text-muted)] text-center">
            {caption}
          </figcaption>
        )}
      </figure>

      <Dialog open={isOpen} onOpenChange={setIsOpen}>
        <DialogContent className="max-w-5xl p-0 bg-[var(--su-bg-primary)] border-[var(--su-border-primary)]">
          <img
            src={src}
            alt={alt}
            className="w-full h-auto max-h-[90vh] object-contain"
          />
          {caption && (
            <div className="p-4 border-t border-[var(--su-border-primary)]">
              <p className="text-sm text-[var(--su-text-muted)] text-center">
                {caption}
              </p>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
